import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { TaskIcons } from '../../Tasks.constants';
import { TextLoading } from '../../../../../../CommonComponents/OPL/Text/Text.loading';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

interface TaskItemLoadingProps {
  icon?: number | null;
  isReport?: boolean;
}

export const TaskItemLoading: React.FC<TaskItemLoadingProps> = ({ icon, isReport }) => {
  return (
    <Box display="flex" justifyContent="space-between" mb={isReport ? undefined : '24'}>
      <Box display="flex" alignItems="center" pr="16">
        <Icon mr="8" className={TaskIcons[icon || 0]} color="neutral.500" />
        <TextLoading width={150} />
      </Box>

      <Box display="flex" alignItems="center" flexShrink={0}>
        {times(3).map(key => (
          <Box key={key} p="4" ml="4">
            <Shimmer width={16} height={16} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
